"use client";

import { useState } from "react";
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { DietListCarouselDefault } from "@/features/diets/components/diet-list-carousel-default";
import type { DietListingBannersType } from "@/features/diets/types/diet-listing-banners.type";
import { BurnBanner } from "@/features/static-builder/components/burn-banner";
import { MobileAppBanner } from "@/features/static-builder/components/mobile-app-banner/mobile-app-banner";
import { MultidietCTAListing } from "@/features/static-builder/components/multidiet-cta-listing";
import { CarouselControls } from "./carousel-controls";

export const DietListCarousel = ({
  data,
  strapiUrl,
}: {
  data: DietListingBannersType;
  strapiUrl: string;
}) => {
  const [api, setApi] = useState<CarouselApi>();

  return (
    <div className="space-y-3">
      <Carousel setApi={setApi}>
        <CarouselContent>
          {data.bannersList.map((banner) => (
            <CarouselItem key={banner.id + banner.__component}>
              {banner.__component === "content.multidet-banner" && (
                <>
                  <MultidietCTAListing data={banner} />
                </>
              )}
              {banner.__component === "content.listing-banner" && (
                <DietListCarouselDefault
                  banner={banner}
                  strapiUrl={strapiUrl}
                />
              )}
              {banner.__component === "blocks.burn-banner" && (
                <BurnBanner
                  data={banner}
                  key={`burn-banner-${banner.id}`}
                  listing
                />
              )}
              {banner.__component ===
                "components.listing-mobile-app-banner" && (
                <MobileAppBanner
                  data={banner}
                  strapiUrl={strapiUrl}
                  variant="listing"
                />
              )}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

      <CarouselControls api={api} slidesCount={data.bannersList.length} />
    </div>
  );
};
